import { constants } from "src/shared/constants";
import {
  FAQS,
  FooterLinks,
  NavSubmenuLinks,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
  HomePageZeroStateDesc,
  RedeemGiftSuccessModalDesc,
} from "./helper";
import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

import MobileBanner from "public/images/cincinnatireds/25-Attend Seat Upgrade-Images_375x550.png";
import DesktopBanner from "public/images/cincinnatireds/25-Attend Seat Upgrade-Images_1920x450.png";

export const tdc_sandbox_pass: TTeamConfig = {
  TEAM_SCHEMA: "tdc_sandbox_pass",
  TEAM_FULL_NAME: "Cincinnati Reds",
  BROWSER_TITLE: "Cincinnati Reds",
  CLIENT_ID: "",
  VENDOR: constants.vendorUUIDs.ticketsdotcom,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#C6011F",
    COLORS_SECONDARY: "#000000",
    LOGOUT_ON_INVALID_SESSION: false,
    IS_INTERCOM_ENABLED: true,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
      ADDITIONAL_SUB_MENU_ITEMS: NavSubmenuLinks,
    },

    DEFAULT_APP_ROUTE: routes.landing,

    ACCOUNT_MANAGER_URL:
      "https://mlb.tickets.com/?orgid=31427&agency=RDMT_MYTIXX&_gl=1*1enisz*_gcl_aw*R0NMLjE3NDA3NzI4NDEuQ2owS0NRaUEyb1ctQmhDMkFSSXNBRFNJQVdxOUlGSW1pNHFxUm5GRU5TNU5BaFFQRFUxYUpVdFpyNlZfZjBIV09RQ21BdUdVT19NYWRTNGFBc0FTRUFMd193Y0I.*_gcl_dc*R0NMLjE3NDA3NzI4NDEuQ2owS0NRaUEyb1ctQmhDMkFSSXNBRFNJQVdxOUlGSW1pNHFxUm5GRU5TNU5BaFFQRFUxYUpVdFpyNlZfZjBIV09RQ21BdUdVT19NYWRTNGFBc0FTRUFMd193Y0I.*_gcl_au*MTY3Mzk0MDU4NC4xNzQwNzcyODM2*_ga*OTQxNTUzODcxLjE3NDA0MTY2MDM.*_ga_N8YFCZLYSZ*MTc0MTIxNTI2NC40LjEuMTc0MTIxNTQ0NC41OS4wLjc3MTg5Nzk2OQ..#/auth/login?fullret=%2Fticketmanagement%2F%3Forgid%3D31427%26agency%3DRDMT_MYTIXX%26_gl%3D1*1enisz*_gcl_aw*R0NMLjE3NDA3NzI4NDEuQ2owS0NRaUEyb1ctQmhDMkFSSXNBRFNJQVdxOUlGSW1pNHFxUm5GRU5TNU5BaFFQRFUxYUpVdFpyNlZfZjBIV09RQ21BdUdVT19NYWRTNGFBc0FTRUFMd193Y0I.*_gcl_dc*R0NMLjE3NDA3NzI4NDEuQ2owS0NRaUEyb1ctQmhDMkFSSXNBRFNJQVdxOUlGSW1pNHFxUm5GRU5TNU5BaFFQRFUxYUpVdFpyNlZfZjBIV09RQ21BdUdVT19NYWRTNGFBc0FTRUFMd193Y0I.*_gcl_au*MTY3Mzk0MDU4NC4xNzQwNzcyODM2*_ga*OTQxNTUzODcxLjE3NDA0MTY2MDM.*_ga_N8YFCZLYSZ*MTc0MTIxNTI2NC40LjEuMTc0MTIxNTQ0NC41OS4wLjc3MTg5Nzk2OQ..%23%2F",

    FOOTER: {
      LINKS: FooterLinks,
    },
  },

  LANDING_PAGE_SETTINGS: {
    SHOW_ALL_PASSES_UNDER_BANNER: true,
    HIDE_UPCOMING_EVENTS: true,

    PASS_BANNER: {
      HIDE_PASS_DETAILS: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    ZERO_STATE: {
      TITLE: "You don’t currently have a pass on your account.",
      DESCRIPTION: <HomePageZeroStateDesc />,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },

    SHOW_MULTIPLE_PASSES: true,
    HIDE_UPCOMING_EVENTS: true,
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
    SEND_GIFT_SUCCESS_MODAL: {
      SEND_NOW_TITLE: "Your gift is on its way!",
      SEND_NOW_DESCRIPTION:
        "Your purchase was successful. The recipient will receive an email shortly with your message and instructions for redeeming their pass.",

      SEND_LATER_TITLE: "Your gift has been scheduled! ",
      SEND_LATER_DESCRIPTION:
        "Your purchase was a success. The recipient will receive their gift email on the scheduled date, complete with your message and simple steps to redeem.",
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
      NO_UPCOMING_RENEWAL_PERIOD_MESSAGE: (
        <>
          You will be able to view and manage your subscriptions after{" "}
          <b>October 15, 2025</b>.
          <br />
          <br />
          If your Kings Pass is a part of an annual plan, it will auto-renew
          monthly through the end of the 2025-2026 regular season. Please note
          that there is no option to cancel this subscription.
        </>
      ),
    },
  },

  REDEEM_GIFT_PAGE_SETTINGS: {
    REDEEM_SUCCESS_MODAL: {
      TITLE: "Congrats!",
      DESCRIPTION: <RedeemGiftSuccessModalDesc />,
    },
  },

  IMAGES: {
    LOGO_URL: "https://ss-leagues.s3.amazonaws.com/MLB-3/CIN-3.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/Cincinnati%20Reds%20Assets/BallparkPerspective3.JPG",
    LANDING_PAGE_STATIC_BANNER_URL: DesktopBanner.src,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: MobileBanner.src,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PASS_PURCHASE_SUCCESS_MESSAGE,
  },
};
